const dateTimezone = (dateStr: string | number, timezone: string) => new Date(new Date(dateStr).toLocaleString('en-US', { timeZone: timezone }));
export default dateTimezone;